import { render, staticRenderFns } from "./collectProducts.vue?vue&type=template&id=86931914&scoped=true"
import script from "./collectProducts.vue?vue&type=script&lang=js"
export * from "./collectProducts.vue?vue&type=script&lang=js"
import style0 from "./collectProducts.vue?vue&type=style&index=0&id=86931914&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86931914",
  null
  
)

export default component.exports